module.exports = __webpack_public_path__ + "img/DJ-Working-Cyber-Magic.e68f21cd.jpg";